import GetInvolvedComponent from "../../components/about/get-involved";

const GetInvolvedPage = () => <GetInvolvedComponent />

export default GetInvolvedPage;